import axios from 'axios';
import config from '../config';
import { getJwt } from '../utils/store';
export default function axiosRequestInterceptor() {
  axios.interceptors.request.use(
    (request) => {
      const urlObj = new URL(request.url);
      //do no set withCredentials property if request is for some other domain
      const healthCheckRegex = /health-check$/g;
      const env = ['production', 'sandbox'].includes(process.env.REACT_APP_ENV)
        ? process.env.REACT_APP_ENV + '.'
        : '';
      if (
        (healthCheckRegex.test(urlObj.pathname) && !urlObj.search) ||
        (urlObj.host !== 'api.' + config.appSettings.host &&
          urlObj.host !== `usage-service.${env}` + config.appSettings.host)
      ) {
        console.log('Debug: Axios returning request without credentials');
        request.withCredentials = false;
        request.headers['Authorization'] = 'Bearer ' + getJwt();
        return request;
      }
      console.log('Debug: Axios returning request with credentials');
      request.withCredentials = true; //send cookie for each request
      return request;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}
